import { gql } from '@apollo/client';

export const CASE_DETAIL_QUERY = gql`
	query Case($id: UUID!) {
		case(id: $id) {
			id
			solved
			patientId
			doctorId
			childId
			isChatActive
			isMyCase
			patient {
				originalId
				id
				profileImageUrl
				profile {
					languageFormatted
				}
				avatarFile {
					createdAt
				}
			}
		}
	}
`;

export const CASE_LIST_ENTRIES = gql`
	query CaseEntries($id: UUID!) {
		caseEntries(
			caseId: $id
			pagination: { take: 9999, order: { how: ASC, key: "created_at" } }
		) {
			data {
				id
				caseId
				message
				type
				time
				createdAt
				senderId
				extra
				thumb
				inDocumentation
				file {
					id
					name
					extension
				}
				avResult
				fileId
				order {
					id
					number
					price {
						priceWithVatRaw
						formattedPrice
						currency
					}
					orderLog {
						type
						value
					}
					orderItems {
						id
						name
						price {
							priceWithVatRaw
							formattedPrice
							currency
						}
					}
				}
				sender {
					id
					profile {
						fullName
					}
				}
			}
		}
	}
`;
